<template>
  <div class="home antialiased font-sans flex flex-col h-full">
    <!-- <Topbar v-if="showTopbar" /> -->
    <router-view v-if="hasLoaded"></router-view>
    <div class="text-center flex flex-col h-full justify-center" v-else>
      <h1
        class="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight"
      >
        Welcome to Carthike
      </h1>
      <div v-if="showAuthError" class="mt-4">
        <p>
          You will be redirected to Shopify admin page, if its not redirected
        </p>
        <button
          @click="openAuthLink"
          class="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded mt-4"
        >
          Click here to open
        </button>
      </div>
    </div>
    <FeedbackModal
      v-if="showFeedbackModal"
      :visible="showFeedbackModal"
      @close="closeFeedbackModal"
    ></FeedbackModal>
  </div>
</template>

<script>
// @ is an alias to /src
// import Topbar from "@/components/Common/Topbar";

import FeedbackModal from "../components/Common/FeedbackModal.vue";

export default {
  name: "Home",
  components: {
    FeedbackModal
    // Topbar
    // Spinner
    // ReviewModal,
  },
  data() {
    return {
      showOnboardingModal: false,
      showReviewModal: false,
      totalRecoveredValue: 0,

      hasLoaded: false,
      isMobile: false,
      showTopbar: false,
      showAuthError: false,
      authErrorUrl: `https://admin.shopify.com/apps/${process.env.VUE_APP_SHOPIFY_API_KEY}`,
      showFeedbackModal: false
    };
  },
  async created() {
    // eslint-disable-next-line
    if (
      !window.shopify ||
      !window.shopify.environment ||
      !window.shopify.environment.embedded
    ) {
      // this.$router.push({ name: "Login" });
      // return;
    }
    // eslint-disable-next-line
    this.isMobile =
      (window.shopify &&
        window.shopify.environment &&
        window.shopify.environment.embedded) ||
      false;

    const response = await this.$store.dispatch("getConfig").catch((err) => {
      if (err.response.status === 401) {
        console.log("err", err);
        window.open(this.authErrorUrl, "_self");
        this.showAuthError = true;
        return;
      }
    });
    if (response && response.needsOauth && response.oauthUrl) {
      open(response.oauthUrl, "_top");
      return;
    }
    this.hasLoaded = true;
    const store = response.store;
    const route = this.$route.path;
    console.log("route", route);
    this.setEmailOnCrisp();
    // this.checkForLocale();
    const shopifyPlan = this.$store.getters.getShopifyPlan;
    if (this.isNotShopifyStaff(shopifyPlan)) {
      this.showTopbar = true;
    }

    this.collectFeedback();

    if (store && store.isPlanSelected) {
      if (route === "/") {
        this.$router.push({ name: "Overview" });
        return;
      }
    }

    if (store && store.isPlanSelected === false) {
      this.$router.push({ name: "Plan" });
    }
  },
  methods: {
    onModalClose() {
      this.showOnboardingModal = false;
    },
    isNotShopifyStaff(planName) {
      return ["custom", "staff", "staff_business"].indexOf(planName) === -1;
    },
    openAuthLink() {
      window.open(this.authErrorUrl, "_self");
    },

    checkForOnboarding() {
      const config = this.$store.getters.getConfig;
      if (
        config &&
        config.createdAt > 1652433630 &&
        config.hasCompletedOnboarding === false
      ) {
        this.$router.push({ name: "Onboarding" });
      }
    },
    parseJwt(token) {
      var base64Payload = token.split(".")[1];
      var payload = Buffer.from(base64Payload, "base64");
      return JSON.parse(payload.toString());
    },
    async setEmailOnCrisp() {
      const response = await this.$store.dispatch("getUser");
      // eslint-disable-next-line
      if (response && response.user && response.user.email && $crisp) {
        

        // eslint-disable-next-line
        $crisp.push(["set", "user:email", [response.user.email]]);
        const store = this.$store.getters.getStore;
        const shopifyPlan = this.$store.getters.getShopifyPlan;
        // eslint-disable-next-line
        $crisp.push([
          "set",
          "session:data",
          [
            [
              ["plan", store.plan],
              ["hasReviewed", store.hasReviewed],
              ["manualMessageSent", store.manualMessageSent],
              ["shopOrigin", store.shopOrigin],
              [
                "sendMessagesUsingDesktopApp",
                store.sendMessagesUsingDesktopApp
              ],
              ["storeId", store.id],
              ["shopifyPlan", shopifyPlan]
            ]
          ]
        ]);
      }
    },

    getTokenFromUrl() {
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop)
      });
      return params.token;
    },
    openEmailSupport() {
      const store = this.$store.getters.getStore;
      let shopOrigin = "";
      if (store && store.shopOrigin) {
        shopOrigin = store.shopOrigin;
      }
      const link = `mailto:help@carthike.com?subject=Support request for ${shopOrigin}`;
      open(link, "_blank");
    },
    checkForLocale() {
      const locale = this.$store.getters.getLocale;
      if (locale && locale.indexOf("en") === -1) {
        setTimeout(() => {
          // eslint-disable-next-line
          new window.google.translate.TranslateElement(
            { pageLanguage: "en" },
            "google_translate_element"
          );
        }, 2000);
        console.log("should show a language selector");
      }
    },
    collectFeedback() {
      // this.showFeedbackModal = true;
    },
    closeFeedbackModal() {
      this.showFeedbackModal = false;
    }
  }
};
</script>
